package com.eladfinish.bible.contest.screens.search.extensions

import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import com.eladfinish.bible.contest.utils.addGershaimAndColon
import com.eladfinish.bible.contest.utils.wrapByGershaim
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

fun VerseUiModel.withGershaimAndColon(): VerseUiModel =
    copy(
        text = text.addGershaimAndColon(),
        highlightedRanges = highlightedRanges
            .map { range ->
                // shift by +1 because of leading quote
                (range.first + 1) until (range.last + 2)
            }
            .toImmutableList(),
    )


fun ImmutableList<VerseUiModel>.withGershaimAndColon():
        ImmutableList<VerseUiModel> =
    map { it.withGershaimAndColon() }
        .toImmutableList()

fun VerseUiModel.withGershaim(): VerseUiModel =
    copy(
        text = text.wrapByGershaim(),
        highlightedRanges = highlightedRanges
            .map { range ->
                // shift by +1 because of leading quote
                (range.first + 1) until (range.last + 2)
            }
            .toImmutableList(),
    )
